// react
import React, { Fragment, useEffect, useReducer, useState } from 'react';

// styles
import styles from './index.module.scss';
// components
import { NavHeader } from '../../../components/navHeader/index';
import { StudentsInfo } from '../../../components/studentInfo/index';
// btn
import { BtnSmall } from '../../../components/btns/btnSmall';
// reducer
import {
  dashboardStatesInitialState,
  dashboardStatesReducer,
} from './indexReducer';

// MUI
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
// router
import { useNavigate } from 'react-router-dom';
// redux
import { useSelector } from 'react-redux';

/***************************************************************************/
/* Name : StudentDataView React Component */
/***************************************************************************/
const StudentDataView = React.memo(() => {
  const navigate = useNavigate();
  // reducer
  const [dashboardStates, dispatchDashboardStates] = useReducer(
    dashboardStatesReducer,
    dashboardStatesInitialState
  );
  const [isSocial, setIsSocial] = useState(false);
  // redux
  const studentData = useSelector((state) => state.ui.studentData);
  const studentObj = useSelector((state) => state.ui.studentObj);
  /******************************************************************/
  /* useEffect */
  /******************************************************************/
  useEffect(() => {
    (async () => {
      // // check if studentData is empty
      if (studentData.length === 0) {
        navigate('/');
      }
    })();
  }, []);
  useEffect(() => {
    if (studentObj && studentObj.college) {
      setIsSocial(studentObj.college === 'كلية الخدمة الاجتماعية');
    }
  }, [studentObj]);
  // snackbar state
  const handleCloseSnackbar = () => {
    dispatchDashboardStates({ type: 'CLEAR' });
  };
  /******************************************************************/
  /* continue */
  /******************************************************************/
  const conntinueHandler = () => {
    navigate('/dashboard/studentDataEnter');
  };
  /******************************************************************/
  /* navigate */
  /******************************************************************/
  const navigateDownload = () => {
    navigate('/dashboard/formsDownload');
  };
  /******************************************************************/
  /* appointment */
  /******************************************************************/
  const appointmentHandler = () => {
    navigate('/dashboard/studentAppointment');
  };
  return (
    <Fragment>
      {<NavHeader title={'بيانات الطالب'} mode={'title'} />}
      <div className={styles['container']}>
        <div className={styles['btns-group']}>
          <BtnSmall
            title={
              studentObj.isComplete ? 'تعديل البيانات' : 'استكمال البيانات'
            }
            onClick={conntinueHandler}
          />
          {studentObj.isComplete && (
            <BtnSmall title={'تنزيل الاستمارات'} onClick={navigateDownload} />
          )}
          {isSocial && studentObj.isComplete && (
            <BtnSmall
              title={'موعد الاختبار الشخصي'}
              onClick={appointmentHandler}
            />
          )}
        </div>
        <StudentsInfo data={studentData} />
      </div>
      {/* ********** ERROR SNACKBAR ********** */}
      <Snackbar
        open={dashboardStates.error}
        onClose={handleCloseSnackbar}
        autoHideDuration={20000}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
      >
        <Alert
          severity='error'
          onClose={handleCloseSnackbar}
          dir='ltr'
          sx={{
            width: '100%',
            backgroundColor: '#D32F2F',
            color: '#fff',
            fontSize: '1.4rem',
            '& .MuiAlert-icon': {
              color: '#fff',
            },
          }}
        >
          !{dashboardStates.errorMessage}
        </Alert>
      </Snackbar>
    </Fragment>
  );
});

export { StudentDataView };
